import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get targets() {
    return ["button", "radioButton", "fromInput", "toInput", "error"]
  }
  static get values() {
    return { name: String, comparison: String, filter: String }
  }

  open(event) {
    if (event.detail.name === this.nameValue) {
      // The dropdown won't be shown without the timeout
      setTimeout(() => {
        this.buttonTarget.click()
      }, 10)
    }
  }

  apply() {
    const checkedRadioButton = this.radioButtonTargets.find(radioButton => radioButton.checked)

    if (checkedRadioButton.value === "*") {
      this.filterValue = "*"
      this.comparisonValue = "any"
    } else if (checkedRadioButton.value === "~") {
      this.filterValue = "~"
      this.comparisonValue = "none"
    } else if (checkedRadioButton.value === "within") {
      if (!this.checkValidRange()) {
        return
      }

      this.filterFrom = this.fromInputTarget.value
      this.filterTo = this.toInputTarget.value
      this.comparisonValue = "within"
    }

    if (this.hasButtonTarget) {
      const dropdown = bootstrap.Dropdown.getInstance(this.buttonTarget)
      dropdown.hide()
    }

    this.dispatchFilterEvent()
  }

  clear() {
    this.filterValue = ""
    this.comparisonValue = ""

    this.dispatchFilterEvent()
  }

  validateRangeInput() {
    if (this.checkValidRange()) {
      this.errorTarget.classList.add("d-none")
      this.toInputTarget.classList.remove("error")
      this.fromInputTarget.classList.remove("error")
    } else {
      this.errorTarget.classList.remove("d-none")
      this.toInputTarget.classList.add("error")
      this.fromInputTarget.classList.add("error")
    }
  }

  dispatchFilterEvent() {
    if (this.comparisonValue === "any" || this.comparisonValue === "none" || this.comparisonValue === "") {
      this.dispatch("filter", { detail: { name: this.nameValue, values: this.filterValue } })
    } else if (this.comparisonValue === "within") {
      this.dispatch("filter", { detail: { name: this.nameValue, values: `${this.filterFrom}:${this.filterTo}` } })
    }
  }

  checkValidRange() {
    const from = Number(this.fromInputTarget.value || this.fromInputTarget.min)
    const to = Number(this.toInputTarget.value || this.toInputTarget.max)
    const min = Number(this.fromInputTarget.min)
    const max = Number(this.toInputTarget.max)

    if (from <= to && from >= min && to <= max) {
      return true
    }

    return false
  }
}
